import { MenuItem, Select } from '@mui/material';
import { useEffect } from 'react';
import { REMOVED_PAYOUT_WARNING } from '../../../../constants/variables';

const RejectShift = ({
  setReasonForScore,
  reasonForScore,
  reasons,
  helperTxt,
  reasonLoading: isLoading
}) => {
  useEffect(() => {
    if (!isLoading && reasons.length > 0) {
      setReasonForScore(
        !reasonForScore
          ? reasons[0].value
          : reasons.find(
              ({ label, value }) =>
                label === reasonForScore || value === reasonForScore
            )?.value || reasons[0].value
      );
    }
  }, [isLoading, reasons, reasonForScore, setReasonForScore]);

  return (
    <div className="d-flex flex-column w-100">
      <Select
        disabled={isLoading}
        value={isLoading ? '' : reasonForScore || ''}
        onChange={(e) => {
          setReasonForScore(e.target.value);
        }}
        displayEmpty
        className="mb-3"
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
              overflowY: 'auto'
            }
          }
        }}
      >
        {isLoading ? (
          <MenuItem value="" disabled>
            Loading...
          </MenuItem>
        ) : (
          reasons?.map((reasonForScore, idx) => {
            return (
              <MenuItem value={reasonForScore.value} key={`${idx}`}>
                {reasonForScore.label}
              </MenuItem>
            );
          })
        )}
      </Select>
      <p style={{ fontSize: '15px', margin: 0, marginTop: '-10px', height: '50px', fontWeight: 700, fontStyle: 'italic' }}>{helperTxt}</p>
      <p style={{ fontSize: '15px', margin: 0, height: '50px', fontWeight: 700, fontStyle: 'italic', color: 'red' }}>{REMOVED_PAYOUT_WARNING}</p>
      {/* <div>
        {(props.isRejectingShift || props.isCancellingShift) && (
          <label htmlFor="Reason" className="m-0 pl-1">
            Reason
          </label>
        )}
        <textarea
          value={props.payExceptionNote}
          onChange={(e) => props.setPayExceptionNote(e)}
          name="pay-exception-note"
          style={{
            resize: 'none',
            overflow: 'auto',
            width: '100%',
            borderRadius: '10px',
            padding: '8px 15px'
          }}
          rows="4"
        />
      </div> */}
    </div>
  );
};

export default RejectShift;
